<template>
  <section>
    <RegisterQueue :data="editQueue" :active="active" :value="value" @dialog:change="eventdialog" />
    <RegisterTypification
      :data="editTypification"
      :active="activeTipifications"
      :value="value"
      @dialog:change="eventdialog"
    />
    <RegisterChildren :data="editChildren" :active="activeChildren" :value="value" @dialog:change="eventdialog" />

    <br /><br />

    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto">
          <v-btn rounded large color="accent shadow-4 px-8" @click="registerQueue">
            Registrar Cola
          </v-btn>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="colas"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
        :expanded.sync="expanded"
        show-expand
        single-expand
      >
        <template v-slot:[`item.typification`]="{ item }">
          {{ item.typification.length !== 0 ? "Posee" : "No posee" }}
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip top color="blue-grey">
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'accent' : 'blue-grey'"
                  @click.stop="registerTypification(item)"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Añadir tipificación</span>
          </v-tooltip>

          <v-tooltip top color="blue-grey">
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn v-on="on" text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handlerEditQueue(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Editar cola</span>
          </v-tooltip>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="deleteQueue(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td class="title pt-3 grey lighten-5" :colspan="headers.length" v-if="item.typification.length !== 0">
            Tipificaciones

            <br />

            <v-card flat outlined>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nombre
                        </th>
                        <th class="text-left">
                          Creación
                        </th>
                        <th class="text-left">
                          Hijos
                        </th>
                        <th class="text-left">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="value in item.typification" :key="value.id">
                        <td>{{ value.name }}</td>
                        <td>{{ value.created_at }}</td>
                        <td>
                          {{ value.children.length > 0 ? "SI" : "NO" }}
                          <v-tooltip bottom color="#3dafa4" v-if="value.children.length > 0">
                            <template v-slot:activator="{ on }">
                              <v-btn icon color="primary" dark v-on="on">
                                <v-icon small class="mr-2" @click.stop="showChildren(item)"
                                  >mdi-eye-plus-outline</v-icon
                                >
                              </v-btn>
                            </template>
                            <span>Ver Informacion Categoría</span>
                          </v-tooltip>
                        </td>

                        <td>
                          <v-tooltip bottom color="#3dafa4">
                            <template v-slot:activator="{ on }">
                              <v-btn icon color="primary" dark v-on="on">
                                <v-icon small class="mr-2" @click.stop="registerChildren(value)"
                                  >mdi-folder-plus-outline</v-icon
                                >
                              </v-btn>
                            </template>
                            <span>Crear Hijo</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
            <br />

            <!-- <tr v-for="value in item.typification" :key="value.id">
              <th class="text-left">Nombre: {{ value.name }}</th>
              <th class="text-left">Creación: {{ value.created_at }}</th>
              <th class="text-left">
                Hijo:
                {{ value.children.length > 0 ? "SI" : "NO" }}
                <v-tooltip bottom color="#3dafa4" v-if="value.children.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="primary" dark v-on="on">
                      <v-icon small class="mr-2" @click.stop="showChildren(item)"
                        >mdi-eye-plus-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Ver Informacion Categoría</span>
                </v-tooltip>
              </th>
              <v-spacer></v-spacer>
              <th class>
                Creación:
                <v-tooltip bottom color="#3dafa4">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="primary" dark v-on="on">
                      <v-icon small class="mr-2" @click.stop="registerChildren(value)"
                        >mdi-folder-plus-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Crear Hijo</span>
                </v-tooltip>
              </th>
            </tr> -->
          </td>

          <td :colspan="headers.length" v-else>
            <span class="teal lighten-2">No Posee Tipificaciones</span>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
            <v-col cols="auto">
                <v-pagination
                    circle
                    color="primary"
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row> -->

    <ShowChildren
      v-if="activeShowChildren"
      :data="showChildreInfo"
      :active="activeShowChildren"
      @dialog:change="eventdialog"
    />
  </section>
</template>

<script>
import RegisterQueue from "./RegisterQueue.vue";
import RegisterTypification from "./Typifications/RegisterTypifications";
import RegisterChildren from "./Children/RegisterChildren";
import ShowChildren from "./Children/ShowChildren";
export default {
  name: "ShowTypifications",
  components: {
    RegisterQueue,
    RegisterTypification,
    RegisterChildren,
    ShowChildren,
  },
  data() {
    return {
      active: false,
      activeTipifications: false,
      activeChildren: false,
      editQueue: {},
      editTypification: {},
      editChildren: {},
      activeShowChildren: false,
      showChildreInfo: {},
      value: 0,
      search: "",
      expanded: [],
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Número",
          value: "number",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Tipificación",
          value: "typification",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "20%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      colas: [],
    };
  },
  created() {
    this.getColas();
  },
  methods: {
    async getColas() {
      try {
        const response = await this.$store.dispatch("queue/SHOW_QUEUE");
        this.colas = response.data.data;
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
        // console.error(error);
      }
    },
    registerQueue() {
      this.active = true;
      this.value = 0;
      this.editQueue = {
        id: "",
        name: "",
        number: "",
        whatsapp: "",
      };
    },
    registerTypification(typifications) {
      this.activeTipifications = true;
      this.value = 0;
      this.editTypification = {
        queue_id: typifications.id,
        name: "",
      };
    },
    registerChildren(item) {
      this.activeChildren = true;
      this.value = 0;
      this.editChildren = {
        queue_id: item.queue_id,
        typification_id: item.id,
        typification_name: item.name,
        name: "",
      };
    },
    showChildren(item) {
      this.activeShowChildren = true;
      this.showChildreInfo = [...item.typification];
    },
    handlerEditQueue(item) {
      this.active = true;
      this.value = 1;
      this.editQueue = {
        id: item.id,
        name: item.name,
        number: item.number,
        whatsapp: item.whatsapp,
        status: item.status,
      };
    },
    async deleteQueue(item) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "¿Seguro?",
          `Está seguro de eliminar la cola ${item.name}. Ésta acción no es reversible`,
        );
        if (confirmRequest.isConfirmed) {
          await this.$store.dispatch("queue/DELETE_QUEUE", {
            id: item.id,
          });

          this.$snotify.success("Cola eliminada.", "¡Hecho!");
        }
      } catch (error) {
        alert(error.response.data.error);
      }
    },
    eventdialog(message) {
      if (message !== "cerrar") {
        this.$snotify.success(message, "¡Hecho!");
        this.activeTipifications = false;
        (this.activeChildren = false), (this.active = false);
        this.activeShowChildren = false;
      }
      this.activeTipifications = false;
      (this.activeChildren = false), (this.active = false);
      this.activeShowChildren = false;
    },
  },
};
</script>
